import { StoreConfig, EntityStore } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { Asset } from '../..';
import { IAssetState } from './asset.state';

@Injectable({ providedIn: 'root' })
@StoreConfig({
  name: 'asset',
  cache: {
    ttl: 15000
  }
})
export class AssetStore extends EntityStore<IAssetState, Asset>  {
  constructor() {
    super();
  }
}
